import { AppIcons } from "../../../data/appIcons";

export const HeaderMenu = [
  {
    id: "projects",
    menuTitle: "Projects",
    menuIcon: AppIcons.binoculars,
    menuKey: 2,
    securityParentMenuKey: null,
    children: [
      {
        id: "Project1",
        menuTitle: "Task Management",
        menuIcon: AppIcons.searchDocument,
        navigationPath: "/child1",
        menuKey: 101,
        securityParentMenuKey: "yourWork",
        children: null,
      },
      {
        id: "Project2",
        menuTitle: "OMS Lite",
        menuIcon: AppIcons.printer,
        navigationPath: "/child2",
        menuKey: 102,
        securityParentMenuKey: "yourWork",
        children: null,
      },
    ],
  },
  
];
